import React from "react";
import moment from "moment";
import { NoAssessments } from "../../patient/InfoTabs/FlaggedJournals";

const PatientAssessmentsOverview = ({
  noTakenAssessments,
  recentAssessments,
}) => {
  return (
    <div className="container-fluid w-100 my-2">
      <div className="d-flex w-100 container-fluid">
        <h5 className="primary-text mb-2">Assessments Taken</h5>
      </div>
      {!noTakenAssessments ? (
        <NoAssessments show_link={false} text="No recent assessments taken!" />
      ) : (
        <div
          className="d-flex w-100"
          style={{
            alignContent: "center",
            alignItems: "start",
            justifyContent: "start",
          }}
        >
          {Object.keys(recentAssessments)
            .filter((item) => {
              if (recentAssessments[item].length > 0) {
                return item;
              }
            })
            .map((assessment) => {
              return (
                <div
                  key={assessment?.id}
                  className="mx-2"
                  style={{
                    borderRadius: "8px",
                    border: "1px solid lightgray",
                    padding: "1% 2%",
                    width: "fit-content",
                  }}
                >
                  <h4 className="primary-text-blue">{assessment}</h4>
                  <label className="d-flex" style={{ gap: "10px" }}>
                    <strong>Date Taken</strong> :{" "}
                    <span>
                      {moment(
                        recentAssessments[assessment][0]?.modified
                      ).format("MM/DD/YYYY")}
                    </span>
                  </label>

                  <label className="d-flex" style={{ gap: "10px" }}>
                    <strong>Score</strong> :{" "}
                    <span>{recentAssessments[assessment][0]?.score}</span>
                  </label>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

export default PatientAssessmentsOverview;
